import { render } from "./CaiGouCompile.vue?vue&type=template&id=c8ee8530"
import script from "./CaiGouCompile.vue?vue&type=script&lang=js"
export * from "./CaiGouCompile.vue?vue&type=script&lang=js"

import "./CaiGouCompile.vue?vue&type=style&index=0&id=c8ee8530&lang=less"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__